import { render, staticRenderFns } from "./close-back.vue?vue&type=template&id=a3501eb6&functional=true&"
import script from "./close-back.vue?vue&type=script&lang=ts&"
export * from "./close-back.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports